module.exports = __webpack_public_path__ + "assets/img/travel-day37.d3ce39b9.png";